import React from 'react';

const PageCover = (props) => {
  return (
    <section className = {`PageCover cover-${props.url} padding-header`}>
      <div className="con">
        <div className="wrap-coverText">
          <h2>{props.title}</h2>
          <p>{props.text}</p>
        </div>
      </div>
    </section>
  );
}

export default PageCover;